export default __webpack_public_path__ + "static/media/BLAZE-Logo-fullColor-DK_1.9a4a11c2.svg";